import { loadPagePropsByCode } from './service';

export const INIT_STATE = 'INIT_STATE';
export const initState = state => ({
    type: INIT_STATE,
    state
});

export const SET_PAGE_PROPS = 'SET_PAGE_PROPS';
export const setPageProps = (id, props={}) => ({
    type: SET_PAGE_PROPS,
    id, props
});

export const SET_LOADING = 'SET_LOADING';
export const setLoading = (isLoading) => ({
    type: SET_LOADING,
    isLoading
});

export const loadPageProps = (domain, id) => {
    return async (dispatch) => {       
        dispatch(setLoading(true));
        let pageInfo = await loadPagePropsByCode(domain, id);

        dispatch(setPageProps(id, pageInfo.data));
        dispatch(setLoading(false));
    };
};


// WEBPACK FOOTER //
// ./_source/cqsx/services/page-model/actions.js